<template>

        <div class="skills-lab-chapters-outer-portal mb3">

            <div class="slide-strip" :style="{width: css_strip_width, left: -(current_page_index * 100) + '%'}">

                <section class="chapter-wrapper" v-for="(chapter, index) in chapters" :style="{width: 'calc(100% / '+chapters.length+')'}">
                    <div class="container pdtb2">
                        <header>
                            <div>
                                <a v-if="chapters[index-1]" href="#" @click.prevent="previousChapter()">{{ chapters[index-1].title }}</a>
                            </div>
                            <h1 class="standard-title">Chapter {{ ('0' + chapter.order).slice(-2) }} - {{ chapter.title }}</h1>
                            <div>
                                <a v-if="chapters[index+1]" href="#" @click.prevent="nextChapter()">{{ chapters[index+1].title }}</a>
                            </div>
                        </header>
                    </div>

                    <section v-for="video in chapter.videos" class="ui-section">
                        <div class="container chapter-list-item">
                            <figure @click="showVideoModal(video.id)" :rel="video.id">
                                <span></span>
                                <img :data-src="'/build/assets/' + video.image.replace('{size}','700')"  :alt="video.title">
                            </figure>
                            <div>
                                <div>
                                    <span>Level {{ textual_numbers[video.order - 1] }}</span>
                                    <h1>{{ video.title }}</h1>
                                </div>
                                <button class="standard-button" @click="showInfoModal(video.title, video.image.replace('185','300'), video.description)">Info</button>
                            </div>
                        </div>
                    </section>

                </section>

            </div>

        </div>

</template>

<script>

var emitter = require('tiny-emitter/instance');

    export default {
    	data(){
    		return {
                css_strip_width: null,
                current_page_index: 0,
                textual_numbers: [
                	'one',
                    'two',
                    'three',
                    'four',
                    'five',
                    'six',
                    'seven',
                    'eight',
                    'nine',
                    'ten',
                    'eleven',
                    'twelve'
                ]
            }
        },
        mounted(){
    		this.getUserData(['chapters']).then(()=>{
    			this.css_strip_width = this.chapters.length * 100 + '%';

    			const self = this;

                let i = 0;
                $('.chapter-list-item figure').each(function(index)
                {

                	// console.log($(this).children('img')[0]);

                    const fig = $(this);
                    const img = fig.children('img')[0];
                    const id  = fig.attr('rel');

                	// const src = $(this).data('src');
                	// const vid_id = parseInt($(this).parent('figure').attr('rel'));
                    //
                	img.addEventListener('load', function(){
                    i++;
                		self.thumbLoaded(fig,i);
                    });
                    img.addEventListener('error', function(){
                    	console.error('image not found ' . i);
                      i++;
                      self.thumbLoaded(fig,i);
                    });

	                // $(this).attr('src', src);
                });

                // load the first thumb to initiate the domino process...

                const src = $('.chapter-list-item figure img').eq(0).data('src');
                $('.chapter-list-item figure img').eq(0).attr('src', src);

		    });
        },
        methods: {
    		thumbLoaded(fig,i)
            {
            	const next_i = parseInt(i) + 1;

            	fig.addClass('loaded');

                const nextthumb = $('.chapter-list-item figure img').eq(i);

                if(nextthumb.length !== 0){
                	const src = nextthumb.data('src');
                	nextthumb.attr('src', src);
                }else {
                  // last thumb loaded, so stop.
                }
            },
    		previousChapter(){
    		    this.current_page_index--;
            },
            nextChapter(){
                this.current_page_index++;
            },
            showVideoModal(video_id)
            {
                emitter.emit('showModal', {
                	video: true,
                    id: video_id
                })
            },
            showInfoModal(title,image,description){
                const media = {
                	display: true,
                    img_src: '/build/assets/' + image.replace('{size}','700')
                };
                const content = '<h1>'+title+'</h1>' + description;
                // EventBus.$emit('showModal', {media, content})
                emitter.emit('showModal', {media, content});
            }
        }
    }

</script>
